import { render, staticRenderFns } from "./youtube.vue?vue&type=template&id=2c51999e&scoped=true&"
import script from "./youtube.vue?vue&type=script&lang=js&"
export * from "./youtube.vue?vue&type=script&lang=js&"
import style0 from "./youtube.vue?vue&type=style&index=0&id=2c51999e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c51999e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/gitlab-runner/builds/X4KPpxnC/0/feng.chen/site-cms/site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c51999e')) {
      api.createRecord('2c51999e', component.options)
    } else {
      api.reload('2c51999e', component.options)
    }
    module.hot.accept("./youtube.vue?vue&type=template&id=2c51999e&scoped=true&", function () {
      api.rerender('2c51999e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/videos/_components/youtube.vue"
export default component.exports